import React from 'react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Button } from '@heroui/react';

interface ExportConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  totalRecords: number;
  resourceLabel: string;
}

export function ExportConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
  totalRecords,
  resourceLabel
}: ExportConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} placement="center" onOpenChange={(open) => !open && onCancel()}>
      <ModalContent>
        {() => (
          <>
            <ModalHeader className="flex flex-col gap-1">Large export confirmation</ModalHeader>
            <ModalBody>
              <p className="leading-7 text-sm">
                There are{' '}
                <span className="font-semibold">
                  {totalRecords.toLocaleString('en-US')}
                </span>{' '}
                {resourceLabel} records to export. This operation may take some time and put
                additional load on the server.
              </p>
              <p className="leading-7 text-sm">
                Do you want to continue and export all of these records to CSV?
              </p>
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={onCancel}>
                Cancel
              </Button>
              <Button color="primary" onPress={onConfirm}>
                Confirm & continue
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}


